module.exports = __webpack_public_path__ + "public/SiteImages/user.svg?0d0fae08";